import {Championships, GimmickMatches, Objectives, Superstars} from "./models.js";

function Property(name, activationValue, tag, rating, superstarName = null, gimmickMatchName = null,
                  championshipName = null) {

    // Integer
    const value = 0;

    // Strings
    const activationText = null;

    // Foreign keys
    const objectiveId = null;

    return {
        name,
        activationText,
        activationValue,
        tag,
        rating,
        superstarName,
        gimmickMatchName,
        championshipName,
        objectiveId,
        value,
    };
}

function getPropertyObjective(property) {
    return Objectives.find({'$loki': property.objectiveId})[0];
}

function addPropertyGimmickMatches(property, gimmickMatches) {
    gimmickMatches.forEach(c => {
        c.propertyId = property.$loki
    });
}

function removePropertyGimmickMatches(property, gimmickMatches) {
    gimmickMatches.forEach(c => {
        c.propertyId = null
    });
}

function getPropertyGimmickMatches(property) {
    return GimmickMatches.find({'propertyId': property.$loki});
}

function addPropertySuperstars(property, superstars) {
    superstars.forEach(c => {
        c.propertyId = property.$loki
    });
}

function removePropertySuperstars(property, superstars) {
    superstars.forEach(c => {
        c.propertyId = null
    });
}

function getPropertySuperstars(property) {
    return Superstars.find({'propertyId': property.$loki});
}

function addPropertyChampionships(property, championships) {
    championships.forEach(c => {
        c.propertyId = property.$loki
    });
}

function removePropertyChampionships(property, championships) {
    championships.forEach(c => {
        c.propertyId = null
    });
}

function getPropertyChampionships(property) {
    return Championships.find({'propertyId': property.$loki});
}

export { Property, getPropertyObjective, addPropertyGimmickMatches, removePropertyGimmickMatches,
    getPropertyGimmickMatches, addPropertyChampionships, removePropertyChampionships, getPropertyChampionships,
    addPropertySuperstars, removePropertySuperstars, getPropertySuperstars}
